import { api } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/comments',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function createComment(ctx, data) {
  try {
    const response = await api({
      url: '/comments',
      method: 'POST',
      data: data
    })
    return response
  } catch (e) {
    throw e
  }
}

